import type { CoachProfile } from '@efdigital/ll-addon-data';
import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coachee/session-card.gts';
import type { CoachingCoacheeCohortSessionsPastModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/sessions/past';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

interface CoachingCoacheeCohortSessionsPastSignature {
  Args: {
    model: CoachingCoacheeCohortSessionsPastModel;
    controller: unknown;
  };
}

function lookupCoach(
  coachUserId: string,
  coaches: CoachProfile[]
): CoachProfile | undefined {
  return coaches.find((coach) => coach.user === coachUserId);
}

export default class CoachingCoacheeCohortSessionsPast extends Component<CoachingCoacheeCohortSessionsPastSignature> {
  @service declare router: RouterService;

  refresh = () => {
    this.router.refresh('coaching.coachee.cohort.sessions.past');
  };

  <template>
    {{pageTitle "Sessions"}}

    <div class={{PAGE_WRAPPER_CONTENT}}>
      {{#if @model.pastSessions.length}}
        <div class="d-flex flex-column gap-4">
          {{#each @model.pastSessions as |session|}}
            {{#let (lookupCoach session.coachUserId @model.coaches) as |coach|}}
              {{#if coach}}
                <SessionCard
                  @session={{session}}
                  @coach={{coach}}
                  @coachingConfig={{@model.coachingConfig}}
                  @planner={{@model.planner}}
                  @onChanged={{this.refresh}}
                />
              {{/if}}
            {{/let}}
          {{/each}}
        </div>
      {{else}}
        <EmptyState @message="You have no session history." />
      {{/if}}
    </div>
  </template>
}
